import { render, staticRenderFns } from "./UserListPage.vue?vue&type=template&id=1e204c73&scoped=true&"
import script from "./UserListPage.vue?vue&type=script&lang=ts&"
export * from "./UserListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e204c73",
  null
  
)

export default component.exports